import { Component, OnInit, Input, ViewChild, ViewContainerRef, TemplateRef, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {MatDialog as MatDialog } from '@angular/material/dialog';
import {MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { RolesDialogeComponent } from '../roles-dialoge/roles-dialoge.component';
import { SnotifyService, SnotifyPosition, ToastDefaults } from 'ng-snotify';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SharedService } from 'src/app/services/shared.service';
import { AuthService } from 'src/app/services/auth.service';
import { SiteService } from 'src/app/sites-management/site.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
// import { Subscription } from 'rxjs';

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.css']
})
export class MenusComponent implements OnInit, OnDestroy {

  menus: any[] = [];
  Categories: any[] = [];
  categoryToEdit: any = {};
  popup: any;
  selectedCategory: any;
  menu: any = {};
  addEditMenu: boolean;
  allPages: any[] = [];
  pages: any[] = [];
  searchText = "";
  filterText = ""
  assigendRole: any[];
  menuLength: number;
  showCheckbox = false;
  selectedMenus: any[] = [];
  btn: any;
  selectedButtonTitle: string;
  modalPage: BsModalRef;
  config = { keyboard: true };
  publishMenuStatus: number;
  CatName: string;
  categoryObject: any;
  siteId: any;
  // addMenuSub: Subscription;
  // subtractMenuSub: Subscription;
  constructor(private httpClient: HttpClient, private authService: AuthService,
    private dialog: MatDialog,
    private sharedService: SharedService,
     private snotifyService: ToastrService,
    private _snackBar: MatSnackBar,
    private modalService: BsModalService,
    private siteService: SiteService
  ) {
    
  }



  ngOnInit() {

    this.siteService.isSiteChanged$.subscribe(
      (res) => this.GetAllMenus()
    )

    this.GetAllMenus();
    this.siteId = this.authService.getLoggedUser().siteId;
  }

  GetAllMenus(id?) {
    // ---
    /*
    this.selectedMenus = [];
    this.httpClient.get('/Categories/GetCategoriesByTypeId/1').subscribe((res: any) => {
      this.Categories = res;
      this.categoryObject = res[0];
      this.GetCategoryMenus(id ? id : res[0].id)
    });
    */

    this.httpClient.get("/CategoriesApi/GetCategoriesById/1").subscribe((res:any) => { 
      console.log(res , 'CAT');
      
      this.Categories = res;
      this.categoryObject = res[0];
      this.GetCategoryMenus(id ? id : res[0].id)
    })
    
  }

  GetCategoryMenus(id?) {
    this.hideCheckBoxHandler();
    this.selectedCategory = id;
    this.httpClient.get(`/Menus/GetMenusByCategoryId/${id}/6`).subscribe((res: any) => {
      this.menus = res.result;
      // this.sortMenu(this.menus);
    });
  }

  refreshMenu($event) {
    this.menu = {};
    this.GetCategoryMenus($event);
  }

  addCategoryMenu(id, name) {
    this.menu = {}

    this.menu.categoriesId = (id) ? id : (this.Categories.length > 0 ? this.Categories[0].id : '0');
    this.menu.categoryName = (name) ? name : (this.Categories.length > 0 ? this.Categories[0].name : 'Menu List');;
    this.addEditMenu = true;
  }

  checkMenuResult($event) {
    if ($event && $event !== 0) {
      this.GetCategoryMenus($event.categoriesId);
      this.openNotifySuccess("Saved")
      this.menu = {};

    }
    this.addEditMenu = false;
  }

  addChildMenu(menu) {
    this.menu = {};
    this.menu.categoriesId = menu.categoriesId;
    this.menu.parentId = menu.id;
    this.menuLength = menu.childs.length;
    this.addEditMenu = true;
  }

  editChildMenu(menu) {
    this.menu = {}
    this.menu = JSON.parse(JSON.stringify(menu));
    this.menu.categoriesId = menu.categoriesId;
    this.menu.externalSlug = menu.slug
    this.menuLength = menu.childs.length;
    this.addEditMenu = true;
  }



  deleteMenu(menu) {
    this.httpClient.post('/Menus/DeleteMenu/' + menu.id, {}).subscribe((res: any) => {
      this.GetCategoryMenus(menu.categoriesId);
      this.openNotifySuccess('Menu deleted successfuly');
    });
  }


  publicUnpublish(menu, status) {
    menu.status = status;
    this.httpClient.post('/Menus/EditMenu/' + menu.id, menu).subscribe((res: any) => {
      if (status == 1) {
        this.openNotifyWarning('Menu Unpublished successfuly');
      } else {
        this.openNotifySuccess('Menu Published successfuly');
      }
    });
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyWarning(message: string) {
    this.snotifyService.warning(message, "",{
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }




  saveCategory(pop, form) {
    if (form.invalid) {
      Object.keys(form.controls).forEach(feild => {
        form.controls[feild].markAsTouched(true);
      });
      return;
    }

    var data = {
      Name: form.value.CatName,
      Slug: form.value.CatName,
      CategoryTypeId: 1
    }
    this.httpClient.post('/Categories/AddCategory', data)
      .subscribe((res: any) => {
        pop.hide();
        this.CatName = data.Name;
        this.openNotifySuccess('Menu Edited successfuly');

        this.selectedMenus = [];
        /*
        this.httpClient.get('/Categories/GetCategoriesByTypeId/1').subscribe((res: any) => {
          this.Categories = res;
          this.categoryObject = res[res.length - 1];
          this.GetCategoryMenus(this.categoryObject.id)
        });
        */
        this.httpClient.get('/CategoriesApi/GetCategoriesById/1').subscribe((res: any) => {
          console.log("CAT MENU COMP" , res);
          
          this.Categories = res;
          this.categoryObject = res[res.length - 1];
          this.GetCategoryMenus(this.categoryObject.id)
        });
      });

  }

  duplicate(form, pop, id) {
    if (form.invalid) {
      Object.keys(form.controls).forEach(feild => {
        form.controls[feild].markAsTouched(true);
      });
      return;
    }

    this.httpClient.post('/Menus/DuplicateMenuCategory', { Name: form.value.CatName, Id: id })
      .subscribe((res: any) => {
        this.selectedCategory = Number(res);
        pop.hide();
        this.CatName = form.value.CatName;
        this.openNotifySuccess('Menu Duplicated successfuly');
        this.GetAllMenus(this.selectedCategory);
        this.GetCategoryMenus(this.selectedCategory)

      });

  }
  saveEditedCategory(form) {
    if (form.invalid) {
      Object.keys(form.controls).forEach(feild => {
        form.controls[feild].markAsTouched(true);
      });
      return;
    }

    var data = {
      Id: this.categoryToEdit.id,
      Name: form.value.CatName,
      Slug: form.value.CatName,
      CategoryTypeId: 1
    }

    this.httpClient.post('/Categories/AddCategory', data).subscribe((res: any) => {

      this.popup.hide()
      this.openNotifySuccess('Menu added successfuly');
      this.GetAllMenus(res)
      this.categoryToEdit = null;
      this.popup = null
    });

  }


  setEditCategory(Cat, pop) {
    this.categoryToEdit = JSON.parse(JSON.stringify(Cat));
    this.popup = pop
  }

  deleteCategory(menu) {
    this.httpClient.get(`/Categories/ChangeCategoryStatus/${menu.id}/3`).subscribe((res: any) => {
      this.openNotifySuccess('Menu Deleted successfuly');
      this.GetAllMenus(menu.id)
    });

  }

  securityDialog(menu) {
    this.httpClient.get(`/Menus/GetMenuAssignedRoles/${menu.id}`).subscribe((res: any) => {
      let dialogRef = this.dialog.open(RolesDialogeComponent, { width: '70vw', data: { unAssigendRole: res.unassingedRoles, assigendRoles: res.assingedRoles } });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          let rolesAndAsigend: any = {
            'id': menu.id,
            'unassingedRoles': result.unAssigendRole,
            'assingedRoles': result.assigendRoles
          }
          this.httpClient.post('/Menus/SaveMenuAssginedRoles', rolesAndAsigend).subscribe((res: any) => {
            this.openNotifySuccess('Assigend Successfully')
          });

        }
      });
    })
  }

  isProhibtedHandler(item: any, index, destinationMenu, isSwap?: Boolean) {
    let result = false;
    if (item.dragData.parent.parentId == this.menus[index].id && !isSwap) {
      return true;
    }

    if (item.dragData.parent.childs) {
      result = this.checkChilds(item.dragData.parent, destinationMenu);
    }
    return result;
  }

  checkChilds(item, destinationItem) {
    let result = false;
    if (!item.childs || item.childs.length == 0)
      return result;
    var recursiveItem = item.childs.find(x => x.id === destinationItem.id || x.id === destinationItem.parentId);
    if (recursiveItem != null) {
      result = true;
    } else {
      item.childs.forEach(childItem => {
        if (childItem.childs && childItem.childs.length > 0) {
          result = this.checkChilds(childItem, destinationItem);
        }
      });
    }
    return result;
  }

  getNewOrder(destinationMenu, isSwap) {
    let newOrder: number = 0;
    if (!isSwap) {
      // When Adding to a destination Menu Item
      if (destinationMenu.childs.length > 0) {
        var maxOrder = destinationMenu.childs[destinationMenu.childs.length - 1].order;
        newOrder = Number(maxOrder) + 1;
      } else {
        newOrder = 1;
      }
    }
    return newOrder;
  }

  moveMenuChild(item: any, index, destinationMenu) {
    if ((item.dragData.parent.parentId === destinationMenu.parentId) && (item.dragData.parent.id === destinationMenu.id)) {
      return
    }
    let isProhibted = this.isProhibtedHandler(item, index, destinationMenu);
    if (!isProhibted) {
      const newOrder = this.getNewOrder(destinationMenu, false);
      let data = {
        'sourceParentId': (item.dragData.parent.parentId) ? item.dragData.parent.parentId : 0,
        'sourceID': item.dragData.parent.id,
        'destinationParentId': (this.menus[index].parentId) ? this.menus[index].parentId : 0,
        'destinationID': this.menus[index].id,
        'newOrder': newOrder,
        'siteId': this.siteId,
        'type': 'add'
      };
      this.AddSwapMenu(data, item);
    }
    else {
      this.openSnackBar("Prohibited scope");
    }
  }

  onDragEnd(event) {
  }

  moveMenu(item: any, index, destinationMenu) {
    if ((item.dragData.parent.parentId === destinationMenu.parentId) && (item.dragData.parent.id === destinationMenu.id)) {
      return
    }
    let isProhibted = this.isProhibtedHandler(item, index, destinationMenu, true);
    if (!isProhibted) {
      const newOrder = this.getNewOrder(destinationMenu, true);
      let data = {
        'sourceParentId': (item.dragData.parent.parentId) ? item.dragData.parent.parentId : 0,
        'sourceID': item.dragData.parent.id,
        'destinationParentId': (this.menus[index].parentId) ? this.menus[index].parentId : 0,
        'destinationID': this.menus[index].id,
        'newOrder': newOrder,
        'siteId': this.siteId,
        'type': 'swap',
        'categoryId': item.dragData.parent.categoriesId ? item.dragData.parent.categoriesId : 0
      };
      this.AddSwapMenu(data, item);
    }
    else {
      this.openSnackBar("Prohibited scope");
    }
  }

  AddSwapMenu(data, item) {
    if (data.sourceID != 0 && data.destinationID != 0) {
      this.httpClient.post(`/Menus/SwapAndAddMenu`, data).subscribe((res: any) => {
        this.openNotifySuccess('Menu order changed successfuly');
        this.GetAllMenus(item.dragData.parent.categoriesId);
      });
    }
  }
  drop(event: CdkDragDrop<any[]>) {
    const item = event.item.data;
    const index = event.currentIndex;
    const destinationMenu = event.container.data; 
  
    if (event.previousContainer === event.container) {
      // Reordering within the same container
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  
      // Update the order of items within the same category in the backend (if needed)
      // ... your logic to update order in the backend ... 
    } else {
      // Moving to a different container
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
  
      if (event.container.id === 'parentList') {
        // Dropped into the main menu list
        this.moveMenu(item, index, destinationMenu);
      } else {
        // Dropped into a child menu list
        const destinationParentMenu = event.container.data[index]; // Get the parent menu of the dropped item
        this.moveMenuChild(item, index, destinationParentMenu); 
      }
    }
  }
  // sortMenu(menuItems) {
  //   menuItems.sort((a, b) => {
  //     return a.order - b.order;
  //   });
  //   menuItems.forEach(element => {
  //     if (element.childs.length > 1) {
  //       this.sortMenu(element.childs);
  //     }
  //   });
  // }

  openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: 2000,
    });
  }

  // isIndeterminate() {
  //   // let isCheckedValue = this.isChecked();
  //   // let isCheckedValue2 = !this.isChecked();
  //   let result = (this.selectedMenus.length > 0 && !this.isChecked());
  //   // return this.sharedService.isIndeterminate(this.selectedMenus);
  //   return result;
  // };

  isChecked() {
    return this.sharedService.isCheckedAll(this.menus);
  };

  toggle(item, event) {
    if (event.target.checked) {
      this.selectedMenus = this.sharedService.addChildMenu(item);
    } else {
      this.selectedMenus = this.sharedService.subtractChildMenu(item);
    }
  }

  toggleAll(event, page?) {
    if (event.target.checked) {
      this.menus.forEach((item) => {
        this.selectedMenus = this.sharedService.addChildMenu(item);
      });
    } else {
      this.menus.forEach((item) => {
        this.selectedMenus = this.sharedService.subtractChildMenu(item);
      });
    }
  }

  exists(item) {
    return this.sharedService.isMenuChecked(item);
  };

  openPagesModal(template: TemplateRef<any>, btn) {
    if (this.selectedMenus.length > 0) {
      this.btn = btn;
      if (btn == "Publish") {
        this.selectedButtonTitle = "Publish/Unpublish selected Menus"
      }
      else if (btn == "Delete") {
        this.selectedButtonTitle = "Delete selected pages"
      }
      this.modalPage = this.modalService.show(template, this.config);
    } else {
      this.snotifyService.error("Please select at least one page", "Error", {
        timeOut: 2000,
        progressBar: true,
        tapToDismiss: true,
      });
    }
  }

  updatePublishedMenus() {
    var status = +this.publishMenuStatus;
    let categoryID = null;
    var menuIds = []
    for (let i = 0; i < this.selectedMenus.length; i++) {
      const element = this.selectedMenus[i];
      categoryID = this.selectedMenus[i].categoriesId;
      menuIds.push(element.id)
    }

    let data = {
      'MenuIds': menuIds,
      'status': status
    }

    this.httpClient.post(`/Menus/publishAllMenus`, data)
      .subscribe((res: any) => {
        this.GetAllMenus(categoryID);
        this.selectedMenus = []
        this.modalPage.hide();
        this.snotifyService.success(
          status == 2 ? 'All selected menu PUBLISHED' : 'All selected menu UNPUBLISHED',
          status == 2 ? 'PUBLISHE' : 'UNPUBLISHE', {
            timeOut: 2000,
            progressBar: true,
            tapToDismiss: true,
        });
      });
  }

  hideCheckBoxHandler() {
    this.showCheckbox = false;
    this.selectedMenus = [];
    this.sharedService.clearSelectedMenus(this.selectedMenus);
  }

  changePopupHandler(popup) {
    this.popup.hide();
  }

  getSelectedMenu(Cat) {
    this.CatName = Cat.name;
    this.categoryObject = Cat;
  }

  ngOnDestroy(): void {
  }
}
